import iconArchivVerwerfen from "../assets/images/Icon_archiv_verwerfen.svg";
import ClosedEyeIcon from "../assets/images/Icon_closed_big_eye.svg";
import OpenEyeIcon from "../assets/images/Icon_open_big_eye.svg";

export const newsActionsLabelsMapping = {
  publish: {
    headerLabel: "Veröffentlicht",
    bodyInfoMessage: `Die ausgewählte Meldung wird mit dem Klick auf den Button "Bestätigen" veröffentlicht.`,
    imageComponent: <img src={OpenEyeIcon} />,
  },
  draft: {
    headerLabel: "Entwurf",
    bodyInfoMessage: `Die ausgewählte Meldung wird mit dem Klick auf den Button "Bestätigen" als Entwurf gespeichert.`,
    imageComponent: <img src={ClosedEyeIcon} />,
  },
  delete: {
    headerLabel: "Löschen",
    bodyInfoMessage: `Die ausgewählte Meldung wird mit dem Klick auf den Button "Bestätigen" gelöscht.`,
    imageComponent: <img src={iconArchivVerwerfen} />,
  },
};

// Schedule Options
export const newsDatierenOptions = [
  {
    label: "Entwurf",
    value: "Entwurf",
  },
  {
    label: "Veröffentlicht",
    value: "Veröffentlicht",
  },
  {
    label: "Datiert",
    value: "Datiert",
  },
];

export const newsStatusFilterOption = {
  Entwurf: "Entwurf",
  Veröffentlicht: "Veröffentlicht",
  Datiert: "Datiert",
};

export const GET_NEWS_DATA_SUCCESS = "GET_NEWS_DATA_SUCCESS";
export const NACHRITEN_DRAFT = "Entwurf";
export const ALLE_OPTION = "Alle";
export const PUBLISH = "publish";
export const DRAFT = "draft";
export const DELETE = "delete";
export const CREATE = "create";
export const EDIT = "edit";
export const LOSCHEN = "Löschen";
